// import React, { useEffect, useRef, useState } from "react";
// import Index from "../Index";
// import Modal from "../modal/Modal";
// import AutoWidthHeight from "../common/AutoWidthHeight";
// import {
//   changeChartView,
//   manageUserSetting,
//   setGridViewStore,
// } from "../../redux/user/action";

// const GridSettings = (props) => {
//   const dispatch = Index.useDispatch();
//   const reduxData = Index.useSelector((state) => state.UserReducer);
//   const { chartView, token, theme } = Index.useSelector(
//     (state) => state.UserReducer
//   );
//   const { height, width } = AutoWidthHeight();
//   const { setgridSettings, gridSettings } = props;
//   const [gridModal, setgridModal] = useState(false);
//   const gridRef = useRef(null);
//   const [opacity, setOpacity] = useState(1);
//   const themeTitle = localStorage.getItem("default-theme");
//   const [grid, setGrid] = useState([
//     [true, false, false, false, false, false, false, false, false],
//     [false, false, false, false, false, false, false, false, false],
//     [false, false, false, false, false, false, false, false, false],
//     [false, false, false, false, false, false, false, false, false],
//     [false, false, false, false, false, false, false, false, false],
//     [false, false, false, false, false, false, false, false, false],
//     [false, false, false, false, false, false, false, false, false],
//   ]);
//   const [gridView, setGridView] = useState(reduxData?.gridView);

//   const handleModel = () => {
//     props.setgridModal(!props.gridModal);
//   };
//   useEffect(() => {
//     // dispatch(setGridViewStore(gridView));
//   }, [gridView]);

//   useEffect(() => {
//     setGrid((e) => {
//       let arr = [...e];
//       for (let main = 0; main < arr.length; main++) {
//         for (
//           let child = 0;
//           child < arr[reduxData?.gridView?.column]?.length;
//           child++
//         ) {
//           arr[main][child] = false;
//         }
//       }
//       for (let main = 0; main < reduxData?.gridView?.column; main++) {
//         for (let child = 0; child < reduxData?.gridView?.row; child++) {
//           arr[main][child] = true;
//           setGridView({
//             column: main + 1,
//             row: child + 1,
//           });
//         }
//       }
//       return arr;
//     });
//   }, []);

//   const handleMouseEnter = (i, index) => {
//     setGrid((e) => {
//       let arr = [...e];
//       for (let main = 0; main < arr.length; main++) {
//         for (let child = 0; child < arr[main].length; child++) {
//           arr[main][child] = main <= i && child <= index;
//         }
//       }
//       return arr;
//     });
//     setGridView({
//       column: i + 1,
//       row: index + 1,
//     });
//   };

//   const handleMouseLeave = () => {
//     setGridView(reduxData?.gridView);
//     setGrid((e) => {
//       let arr = [...e];
//       for (let main = 0; main < arr.length; main++) {
//         for (let child = 0; child < arr[main].length; child++) {
//           arr[main][child] =
//             main < reduxData?.gridView?.column &&
//             child < reduxData?.gridView?.row;
//         }
//       }
//       return arr;
//     });
//   };

//   const handleGridChange = (column, row) => {
//     if (gridRef.current) {
//       clearTimeout(gridRef.current);
//       gridRef.current = null;
//     }
//     gridRef.current = setTimeout(() => {
//       setGridView({
//         column,
//         row,
//       });
//       dispatch(
//         setGridViewStore({
//           column,
//           row,
//         })
//       );
//       dispatch(
//         manageUserSetting(token, "gridView", {
//           column,
//           row,
//         })
//       );
//     }, 200);
//     props?.setShow(!props?.show);
//   };

//   return (
//     <>
//       <Index.Box className="grid-setting-wrapper">
//         <Index.Box className="grid-main">
//           <Index.Box className="grid-col">
//             {grid.map((e, i) => {
//               return (
//                 <div className="grid-sec" key={`grid-setting-row-${i}`}>
//                   {e.length
//                     ? e.map((el, index) => {
//                         return (
//                           <Index.Box
//                             key={`grid-setting-col-${index}`}
//                             onClick={() => {
//                               setGrid((e) => {
//                                 let arr = [...e];
//                                 for (let main = 0; main < arr.length; main++) {
//                                   for (
//                                     let child = 0;
//                                     child < arr[i].length;
//                                     child++
//                                   ) {
//                                     arr[main][child] = false;
//                                   }
//                                 }
//                                 for (let main = 0; main <= i; main++) {
//                                   for (let child = 0; child <= index; child++) {
//                                     arr[main][child] = true;
//                                     handleGridChange(main + 1, child + 1);
//                                   }
//                                 }
//                                 return arr;
//                               });
//                               dispatch(changeChartView());
//                             }}
//                             onMouseEnter={() => handleMouseEnter(i, index)}
//                             onMouseLeave={handleMouseLeave}
//                             className={`grid-box ${el ? "active" : ""}`}
//                           ></Index.Box>
//                         );
//                       })
//                     : ""}
//                 </div>
//               );
//             })}
//           </Index.Box>
//           <Index.Box className="grid-size">
//             <Index.Typography className="four-text" variant="p" component="p">
//               {gridView?.column} X {gridView?.row}
//             </Index.Typography>
//             <img
//               className={`setting-white-img ${
//                 theme === "Light" && "custom-dark-setting"
//               }`}
//               alt="settingWhiteIc"
//               src={Index.Svg.settingWhiteIc}
//               onClick={(e) => {
//                 props.handleElementClick(e, 550, -250);
//                 handleModel();
//               }}
//             />
//           </Index.Box>
//         </Index.Box>
//       </Index.Box>
//     </>
//   );
// };

// export default GridSettings;
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  changeChartView,
  manageUserSetting,
  setGridViewStore,
} from "../../redux/user/action";
import Index from "../Index";

// Constants for grid dimensions
const GRID_ROWS = 7;
const GRID_COLS = 9;

const GridSettings = ({
  setgridModal,
  gridModal,
  setShow,
  show,
  handleElementClick,
}) => {
  const dispatch = useDispatch();
  const { token, theme, gridView } = useSelector((state) => state.UserReducer);

  // Initialize grid state with memoized initial value
  const [grid, setGrid] = useState(() => {
    const initialGrid = Array(GRID_ROWS)
      .fill()
      .map(() => Array(GRID_COLS).fill(false));
    return initialGrid;
  });

  const [localGridView, setLocalGridView] = useState(
    gridView || { column: 1, row: 1 }
  );

  // Toggle modal
  const handleModal = () => setgridModal(!gridModal);

  // Initialize grid based on redux gridView
  useEffect(() => {
    setGrid((prev) => {
      const newGrid = prev.map((row) => row.slice());
      for (let row = 0; row < GRID_ROWS; row++) {
        for (let col = 0; col < GRID_COLS; col++) {
          newGrid[row][col] = row < gridView.column && col < gridView.row;
        }
      }
      return newGrid;
    });
    setLocalGridView(gridView);
  }, [gridView]);

  // Handle mouse enter to highlight grid
  const handleMouseEnter = (row, col) => {
    setGrid((prev) => {
      const newGrid = prev.map((r) => r.slice());
      for (let r = 0; r < GRID_ROWS; r++) {
        for (let c = 0; c < GRID_COLS; c++) {
          newGrid[r][c] = r <= row && c <= col;
        }
      }
      return newGrid;
    });
    setLocalGridView({ column: row + 1, row: col + 1 });
  };

  // Reset grid on mouse leave
  const handleMouseLeave = () => {
    setGrid((prev) => {
      const newGrid = prev.map((row) => row.slice());
      for (let row = 0; row < GRID_ROWS; row++) {
        for (let col = 0; col < GRID_COLS; col++) {
          newGrid[row][col] = row < gridView.column && col < gridView.row;
        }
      }
      return newGrid;
    });
    setLocalGridView(gridView);
  };

  // Handle grid selection with debouncing
  const handleGridChange = (column, row) => {
    const newGridView = { column, row };
    setLocalGridView(newGridView);
    dispatch(setGridViewStore(newGridView));
    dispatch(manageUserSetting(token, "gridView", newGridView));
    dispatch(changeChartView());
    setShow(!show);
  };

  return (
    <div className="grid-setting-wrapper">
      <div className="grid-main">
        <div className="grid-col">
          {grid.map((row, rowIndex) => (
            <div className="grid-sec" key={`grid-row-${rowIndex}`}>
              {row.map((isActive, colIndex) => (
                <div
                  key={`grid-col-${colIndex}`}
                  className={`grid-box ${isActive ? "active" : ""}`}
                  onClick={() => {
                    setGrid((prev) => {
                      const newGrid = prev.map((r) => r.slice());
                      for (let r = 0; r < GRID_ROWS; r++) {
                        for (let c = 0; c < GRID_COLS; c++) {
                          newGrid[r][c] = r <= rowIndex && c <= colIndex;
                        }
                      }
                      return newGrid;
                    });
                    handleGridChange(rowIndex + 1, colIndex + 1);
                  }}
                  onMouseEnter={() => handleMouseEnter(rowIndex, colIndex)}
                  onMouseLeave={handleMouseLeave}
                />
              ))}
            </div>
          ))}
        </div>
        <div className="grid-size">
          <p className="four-text">{`${localGridView.column} X ${localGridView.row}`}</p>
          <img
            className={`setting-white-img ${
              theme === "Light" ? "custom-dark-setting" : ""
            }`}
            alt="settingWhiteIc"
            src={Index.Svg.settingWhiteIc}
            onClick={(e) => {
              handleElementClick(e, 550, -250);
              handleModal();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default GridSettings;
